import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { FilterValue } from '../../../../app/interfaces/base/filter-value';
import { FormControl } from '@angular/forms';
import { ApiService } from '../../../../app/services/base/api.service';

@Component({
  selector: 'fury-table-filter-initials',
  templateUrl: './table-filter-initials.component.html',
  styleUrls: ['./table-filter-initials.component.scss']
})
export class TableFilterInitialsComponent implements AfterViewInit, OnDestroy {

  public isFiltered: boolean = false;

  @Input() name: string = null;
  @Input() customFiltering: boolean = false;
  @Input() setValue: EventEmitter<any> = new EventEmitter();

  @Output() clearFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();

  public element: FormControl = new FormControl<string>('');
  private value: string = '';
  private debounce: any = null;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private api: ApiService,
              private cd: ChangeDetectorRef) {
  }

  @HostListener('keydown.space', ['$event'])
  @HostListener('click', ['$event']) onClick(e: Event): void {
    e.stopPropagation();
  }

  ngAfterViewInit(): void {
    this.element.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: string): void => {
      this.isFiltered = !!value;

      if (value) {
        if (this.value && this.value.length > value.length) {
          const newValue: string = [...value.slice(0, -2).toUpperCase().replace(/\./g, '')].join('.');
          value = (newValue.length ? newValue + '.' : '');
        } else {
          value = [...value.toUpperCase().replace(/\./g, '')].join('.') + '.';
        }
      }

      this.value = value;
      this.element.setValue(value, {emitEvent: false});
      this.cd.detectChanges();

      if (this.debounce) {
        clearTimeout(this.debounce);
      }

      this.debounce = setTimeout((): void => {
        if (this.customFiltering) {
          (value ? this.filterChange.emit(value) : this.clearFilter.next());
        } else {
          (value ? this.api.setFilter(this.name, value) : this.api.clearFilter(this.name));
        }

        this.cd.detectChanges();
      }, 500);
    });

    this.api.preSetFilters.pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe((filters: FilterValue[]): void => {
      filters.forEach((filter: FilterValue): void => {
        if (this.name === filter.name) {
          this.isFiltered = !!filter.value;

          if (filter.value) {
            this.element.setValue(filter.value, {emitEvent: false});
            this.value = <any>filter.value;
          }

          this.cd.detectChanges();
        }
      });
    });

    this.setValue.pipe(takeUntil(this.destroy$)).subscribe((value: string): void => {
      this.isFiltered = !!value !== null;
      this.element.setValue(value, {emitEvent: false});
      this.value = value;
    });

    this.api.filterCleared.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton());
    this.api.clearAllFilters.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton(false));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clearFilterButton(emitEvent: boolean = true): void {
    this.element.setValue('', {emitEvent: false});
    this.isFiltered = false;

    if (emitEvent) {
      if (this.customFiltering) {
        this.clearFilter.next();
      } else {
        this.api.clearFilter(this.name);
      }
    }
  }
}
